/**
 * @file hooks/biz/dialog 弹框hooks
 * @author zhangzhe(zhangzhe@baidu.com)
 */

import React, {useState, useCallback, useMemo, useEffect} from 'react';
import {useSwitch} from '@huse/boolean';

import {createDialog, createDrawer} from '../../../components';

import {useLocale} from '../../../components/locale';

export interface DialogOption {
    wrappedComponent: React.ReactNode;
    type?: 'dialog' | 'drawer';
    dialogType?: 'plain' | 'common'; // 枚举值
    className?: string;
    prefixCls?: string;
    title?: string;
    width?: number;
    maskClosable?: boolean;
    cancelWithSuccess?: boolean;
    foot?: boolean;
    okText?: string;
    cancelText?: string;
    payload?: any;
    fromTable?: boolean;
    mask?: boolean; // 是否展示遮罩
    acudProps?: any;
    customCancelHandler?: () => Promise<any>;
}
export interface DialogOptionText {
    sure?: string;
    cancel?: string;
    submitting?: string;
}

const useDialog: any = () => {
    const [dialogOpen, showDialog, hideDialog] = useSwitch(false);
    const [dialogOptions, setDialogOptions]: [DialogOption | undefined, any] = useState();
    const [locale] = useLocale('useDialog');
    const dialogOptionText = {
        'sure': locale?.sure,
        'cancel': locale?.cancel,
        'submitting': locale?.submitting
    };
    const Dialog = useMemo(() => {
        if (dialogOptions) {
            const {type = 'dialog'} = dialogOptions;
            if (type === 'dialog') {
                return createDialog(dialogOptions, dialogOptionText)(dialogOptions.wrappedComponent);
            }
            else if (type === 'drawer') {
                return createDrawer(dialogOptions, dialogOptionText)(dialogOptions.wrappedComponent);
            }
        }
        return null;
    }, [dialogOptions]);

    const handleDialogCancel = useCallback(() => {
        // 先关掉弹框
        hideDialog();
        // 清空弹框设置
        setDialogOptions(null);
    }, [hideDialog]);

    useEffect(() => {
        if (Dialog) {
            showDialog();
        }
    }, [Dialog, showDialog]);

    return {
        Dialog,
        dialogOpen,
        showDialog,
        hideDialog,
        dialogOptions,
        setDialogOptions,
        handleDialogCancel
    };
};

export default useDialog;
